import { slideDown, slideUp } from '../utiles/index.js';
import axios from 'axios';
import { checkAutoplaySupport } from '../utiles/index.js';

const initPage = () => {
	let videoAutoplaySupported = true;
	(async () => {
		const autoplaySupport = await checkAutoplaySupport({ muted: true });
		videoAutoplaySupported = autoplaySupport.muted;
		console.log(videoAutoplaySupported, 'supported');
	})();

	// 禁止图片和视频触发右键菜单（防止直接另存为）
	document.addEventListener('contextmenu', function (e) {
		// 检查被点击的元素是否为图片或视频
		if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO' || e.target.tagName === 'BUTTON') {
			e.preventDefault();
			return false;
		}
	});

	// Contact
	const btnShowBusinessQR = document.querySelector('.js-show-business-qrcode');
	if (btnShowBusinessQR) {
		const layerBusinessQR = document.querySelector('.layer-business-qrcode-box');
		const btnCloseBusinessQR = document.querySelector('.layer-business-qrcode-close');
		btnCloseBusinessQR.addEventListener('click', () => {
			layerBusinessQR.classList.remove('show');
		});
		btnShowBusinessQR.addEventListener('click', () => {
			layerBusinessQR.classList.add('show');
		});
	}

	const expandItems = document.querySelectorAll('.expand-item');
	if (expandItems.length) {
		expandItems.forEach((item) => {
			const btn = item.querySelector('.expand-item__header');
			const content = item.querySelector('.expand-item__body');
			btn.addEventListener('click', () => {
				if (item.classList.contains('show')) {
					item.classList.remove('show');
					slideUp(content);
				} else {
					item.classList.add('show');
					slideDown(content);
				}
			});
		});
	}

	// Scrolling Number
	function animateNumber(el, start, end, duration) {
		let startTime = null;

		function step(timestamp) {
			if (!startTime) startTime = timestamp;
			const progress = Math.min((timestamp - startTime) / duration, 1);

			// 数字插值
			const value = Math.floor(progress * (end - start) + start);

			el.textContent = value < 1000000 ? value : value.toLocaleString(); // 千分位格式化
			// el.textContent = value.toLocaleString();

			if (progress < 1) {
				requestAnimationFrame(step);
			}
		}

		requestAnimationFrame(step);
	}

	const scrollNums = document.querySelectorAll('.scroll-num-box');
	if (scrollNums.length) {
		scrollNums.forEach((numbox) => {
			// console.log(window.getComputedStyle(numbox));
			numbox.setAttribute('data-animate', 'true');
			numbox.addEventListener('transitionend', () => {
				if (numbox.getAttribute('data-animate') == 'true') {
					const numNode = numbox.querySelector('.scroll-num');

					const endNum = parseInt(numNode.innerHTML.replace(/,/g, ''));
					// const startNum = parseInt(`1${'0'.repeat(Math.abs(endNum).toString().length - 1)}`);
					const startNum = parseInt(numNode.dataset.start);
					// console.log('num', numNode, endNum, Math.abs(endNum).toString().length);
					animateNumber(numNode, startNum, endNum, 1000);
				}
				numbox.setAttribute('data-animate', 'false');
			});
		});
	}

	const commVideoBoxs = document.querySelectorAll('.comm-video-box');
	if (commVideoBoxs.length) {
		commVideoBoxs.forEach((box) => {
			const video = box.querySelector('video');
			if (video.dataset.srcPc) {
				const isMobile = window.innerWidth < 641;
				const src = isMobile ? video.dataset.srcM : video.dataset.srcPc;
				const poster = isMobile ? video.dataset.posterM : video.dataset.posterPc;

				if (src) {
					video.src = src;
				}
				if (poster) {
					video.poster = poster;
				}
			}

			box.setAttribute('data-animate', 'true');
			box.addEventListener('transitionend', () => {
				if (box.getAttribute('data-animate') == 'true') {
					video.play();
				}
				box.setAttribute('data-animate', 'false');
			});
		});

		let resizeTimer;
		window.addEventListener('resize', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				commVideoBoxs.forEach((box) => {
					const video = box.querySelector('video');
					const isMobile = window.innerWidth < 641;
					const src = isMobile ? video.dataset.srcM : video.dataset.srcPc;
					// const poster = isMobile ? video.dataset.posterM : video.dataset.posterPc;

					if (src && src !== video.src) {
						const currentTime = video.currentTime;
						video.src = src;
						// video.load();
						// video.currentTime = currentTime;
						video.play();
					}
				});
			}, 250);
		});
	}

	const bindWorkItemVideo = (items) => {
		if (!items.length) return;
		items.forEach((work) => {
			// 防止重复绑定
			if (work.dataset.hasBindVideo) return;
			work.dataset.hasBindVideo = 'true';

			const videoSrc = work.dataset.video;
			const isAutoplay = work.dataset.autoplay;
			if (videoSrc) {
				const box = work.querySelector('.work-item__img-box');
				const videoHTML = `<video class="work-item__img absolute top-0 left-0" preload="none" x-webkit-airplay="true" airplay="allow" webkit-playsinline="true" playsinline="true" x5-video-player-fullscreen="true" autoplay muted loop controlsList="nodownload" src="${videoSrc}" type="video/mp4" />`;
				const temp = document.createElement('div');
				if (isAutoplay === 'true') {
					temp.innerHTML = videoHTML;
					box.appendChild(temp);
				} else {
					work.addEventListener('mouseenter', () => {
						temp.innerHTML = videoHTML;
						box.appendChild(temp);
						const video = temp.querySelector('video');
						// 确保视频加载并播放
						if (video) {
							video.currentTime = 0;
							video.play().catch((e) => console.log('Autoplay prevented', e));
						}
					});
					work.addEventListener('mouseleave', () => {
						temp.remove();
					});
				}
			}
		});
	};

	const workItems = document.querySelectorAll('.work-item');
	bindWorkItemVideo(workItems);

	// Load More Works
	const btnLoadMore = document.querySelector('.js-load-more');

	if (btnLoadMore) {
		const workListBox = document.querySelector('.js-list-works');
		const btnGotop = document.querySelector('.js-gotop');
		let nextPage = document.querySelector('.page-next');

		const btnLoadMoreSvg = btnLoadMore.querySelector('use');

		const hideLoadMore = () => {
			btnLoadMore.closest('div').remove();
			btnGotop.closest('div').classList.remove('hidden');
		};
		if (!nextPage) {
			hideLoadMore();
		}

		btnLoadMore.addEventListener('click', () => {
			console.log('click', nextPage);
			if (nextPage) {
				btnLoadMore.setAttribute('disabled', true);
				const url = nextPage.getAttribute('href');
				console.log(url);
				btnLoadMore.classList.add('loading');
				btnLoadMoreSvg.setAttribute('xlink:href', '#icon-loading');
				axios.get(url).then((res) => {
					// console.log(res);
					const html = res.data;
					const parser = new DOMParser();
					const doc = parser.parseFromString(html, 'text/html');
					const workListHTML = doc.querySelector('.js-list-works').innerHTML;
					const npage = doc.querySelector('.page-next');
					if (workListHTML) {
						// console.log(productsList);
						const tempDiv = document.createElement('div');
						tempDiv.innerHTML = workListHTML;

						// 获取新生成的 work-item 节点列表
						const newItems = tempDiv.querySelectorAll('.work-item');

						// 绑定：对新元素执行绑定逻辑
						bindWorkItemVideo(newItems);

						// 将新节点移动到真实 DOM 中
						while (tempDiv.firstChild) {
							workListBox.appendChild(tempDiv.firstChild);
						}

						btnLoadMore.removeAttribute('disabled');
						btnLoadMoreSvg.setAttribute('xlink:href', '#icon-plus');
						btnLoadMore.classList.remove('loading');
					}
					if (npage) {
						nextPage = npage;
					} else {
						nextPage = null;
						hideLoadMore();
					}
				});
			}
		});
	}

	// Work Details Video
	const workdVideos = document.querySelectorAll('.workd-video');
	if (workdVideos.length) {
		(async () => {
			workdVideos.forEach((workdvideo) => {
				const video = workdvideo.querySelector('video');
				if (!video) return;

				if (video.autoplay) {
					console.log('autoplay');
					workdvideo.setAttribute('data-play', 'true');
					return;
				}

				// 初始化状态
				workdvideo.setAttribute('data-play', 'false');
				video.removeAttribute('controls');

				// 更新 UI 状态
				const updateUI = () => {
					if (video.paused) {
						workdvideo.setAttribute('data-play', 'false');
						video.removeAttribute('controls');
					} else {
						workdvideo.setAttribute('data-play', 'true');
						video.setAttribute('controls', 'true');
					}
				};

				// 监听视频事件
				video.addEventListener('play', updateUI);
				video.addEventListener('pause', updateUI);
				video.addEventListener('ended', updateUI);

				workdvideo.addEventListener('click', (e) => {
					// 如果点击的是视频本身（如控件或视频区域），则忽略，交由原生行为处理
					if (e.target === video) return;

					if (video.paused) {
						video.play();
					} else {
						video.pause();
					}
				});
			});
		})();
	}
};

export { initPage };
